module.exports = __webpack_public_path__ + "img/icon64.4de19c9c.png";